// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"3190cf46","538":"116adc23","612":"7f47f5ef"}[chunkId] + ".js";
};